import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-dashboard-table-skeleton',
  templateUrl: './dashboard-table-skeleton.component.html',
})
export class DashboardTableSkeletonComponent {
  @Input() columnCount = 6;
  @Input() rows = 4;
  @Input() columnWidths: string[] = [];
  @Input() firstColAvatar = true;
  @Input() firstColMultiLine = false;
  @Input() secondColMultiLine = false;

  get columns(): number[] {
    return Array.from({ length: this.columnCount }, (_, index) => index);
  }

  get rowPlaceholders(): number[] {
    return Array.from({ length: this.rows }, (_, index) => index);
  }

  getColumnWidth(index: number): string {
    return this.columnWidths[index] ?? '';
  }
}
